<template>
  <div class="home-new">
    <video
      id="video"
      v-show="showVideo"
      class="video"
      :src="videoSrc"
      controls
    ></video>
    <Hero @changeShowVideo="showVideo = $event" />
    <whyEberza />
    <eBusiness />
    <About />
    <ContactUs />
    <LatestNews />
    <FriendsSite @changeShowVideo="showVideo = $event" :showVideo="showVideo" />
    <Newsletter />
  </div>
</template>
<script>
import Hero from "../components/homeNew/Hero.vue";
import whyEberza from "../components/homeNew/WhyBerza";
import eBusiness from "../components/homeNew/eBusiness";
import About from "../components/homeNew/About.vue";
import ContactUs from "../components/homeNew/ContactUs.vue";
import LatestNews from "../components/homeNew/LatestNews.vue";
import FriendsSite from "../components/homeNew/FriendsSite.vue";
import Newsletter from "../components/homeNew/Newsletter.vue";

import { api, baseURL } from "@/api";

export default {
  name: "home",
  components: {
    Hero,
    whyEberza,
    eBusiness,
    About,
    ContactUs,
    LatestNews,
    FriendsSite,
    Newsletter
  },
  data() {
    return {
      videoSrc: "https://eberza.e-lite.info/video/demo.mp4",
      showVideo: false
    };
  },
  mounted() {
    // this.setEvent();
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
    document.addEventListener(
      "webkitfullscreenchange",
      this.handleFullscreenChange
    );
    document.addEventListener(
      "mozfullscreenchange",
      this.handleFullscreenChange
    );
    document.addEventListener(
      "msfullscreenchange",
      this.handleFullscreenChange
    );
    // ios
    document
      .getElementById("video")
      .addEventListener("webkitendfullscreen", this.onExitFullscreen);
  },
  activated() {
    // this.setEvent();
  },
  beforeDestroy() {
    // Uklanjamo event listener kada se komponenta uništi
    document.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener(
      "webkitfullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener(
      "mozfullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener(
      "msfullscreenchange",
      this.handleFullscreenChange
    );
    // ios
    document
      .getElementById("video")
      .removeEventListener("webkitendfullscreen", this.onExitFullscreen);
  },
  methods: {
    onExitFullscreen() {
      // Ova metoda se poziva kad iOS zatvori fullscreen video
      console.log("iOS izašao iz fullscreen video moda");
      this.showVideo = false;
    },
    handleFullscreenChange(event) {
      let fullscreenElement =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement;

      console.log(fullscreenElement, "fullscreenElement++++++++++");
      if (!fullscreenElement) {
        this.showVideo = false;
      }
    },
    // setEvent() {
    //   document.onfullscreenchange = event => {
    //     let fullscreenElement =
    //       document.fullscreenElement ||
    //       document.mozFullScreenElement ||
    //       document.webkitFullscreenElement ||
    //       document.msFullscreenElement;
    //     console.log(fullscreenElement, "fullscreenElement++++++++++");
    //     if (fullscreenElement) {
    //     } else {
    //       this.showVideo = false;
    //     }
    //   };
    // },

    getVideoSrc() {
      // console.log(baseURL.replace("api", ""));
      if (this.$route.params.lang === "sr") {
        this.videoSrc = baseURL.replace("api", "") + "video/demo.mp4";
      } else {
        this.videoSrc = baseURL.replace("api", "") + "video/demo-english.mp4";
      }
    }
  },
  watch: {
    "$route.params.lang": {
      handler: function() {
        this.getVideoSrc();
      },
      deep: true,
      immediate: true
    },
    showVideo: {
      handler: function() {
        let element = document.querySelector("#video");
        if (this.showVideo) {
          const isIOS =
            /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

          if (!isIOS) {
            element.requestFullscreen();
          }
          // element.requestFullscreen();
          element.play();
        } else {
          element.pause();
        }
      }
    }
  }
};
</script>
<style>
.home-new {
  width: 100%;
}
</style>
